import { useEffect } from "react";
import { defaultLang } from "@excalidraw/excalidraw/i18n";

import { atom, useAtom } from "../app-jotai";

export const appLangCodeAtom = atom(defaultLang.code);

export const useAppLangCode = () => {
  const [langCode, setLangCode] = useAtom(appLangCodeAtom);

  useEffect(() => {
    // English-only mode: keep language fixed to default.
    if (langCode !== defaultLang.code) {
      setLangCode(defaultLang.code);
    }
  }, [langCode, setLangCode]);

  return [langCode, setLangCode] as const;
};
